import thunk from 'redux-thunk';
import {createBrowserHistory} from 'history';
import {routerMiddleware, routerReducer} from 'react-router-redux';
import immutableStateInvariant from 'redux-immutable-state-invariant';
import {applyMiddleware, createStore, compose, combineReducers} from 'redux';

import * as reducers from '../reducers';

const history = createBrowserHistory();
const router = routerMiddleware(history);
const immutable = immutableStateInvariant();

const rootReducer = combineReducers({
    router: routerReducer,
    ...reducers
});

const middleware =
    process.env.NODE_ENV !== 'production' ?
        [immutable, router, thunk]
        :
        [router, thunk];

const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        :
        compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const configureStore = initialState => {
    return createStore(rootReducer, initialState, enhancer);
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/index.js